import { useLoyaltyPoints } from "../loyalty/useLoyaltyPoints";
import type { RewardResponse } from "../rewards/rewardsApi";

export const useCanBuyReward = (reward: RewardResponse | null, role: string | null) => {
  const { loyaltyPoints, isLoading } = useLoyaltyPoints(role == "CUSTOMER");
  if (role !== "CUSTOMER") {
    return { canBuy: false, isLoading: false, message: "Kup" };
  }
  if (reward == null) {
    return { canBuy: false, isLoading: true, message: null };
  }
  if (isLoading) {
    return { canBuy: false, isLoading, message: null };
  }
  const canBuy = !!loyaltyPoints?.points && loyaltyPoints.points >= reward.cost;
  return { canBuy, isLoading, message: canBuy ? null : `Za mało punktów.` };
};
